import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M7.7 14.4A6.7 6.7 0 107.7 1a6.7 6.7 0 000 13.4z" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10" /><path d="M15.2 15.3l4 4" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" /></svg>);